import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Text } from '@moda/om';
import { hrefFor } from '../../routers';
import { tc } from '../../lib/trackingContext';
import { useUser } from '../../hooks/useUser';
import { EmailVerificationStatusModal } from './EmailVerificationStatusModal';

export type EmailVerificationStatusSuccessProps = { show: boolean; onHide: () => void };

export const EmailVerificationStatusSuccess: React.FC<EmailVerificationStatusSuccessProps> = ({
  show,
  onHide
}) => {
  const { user } = useUser();
  const history = useHistory();

  useEffect(() => {
    if (show) {
      tc.track('Welcome Window Viewed');
      tc.track('Registration Completed', { addToTrackingEvent: { label: user.id || '' } });
    }
  }, [show, user.id]);

  const handleHide = () => {
    onHide();
    history.replace(hrefFor.HomePage());
  };

  return (
    <EmailVerificationStatusModal
      show={show}
      title="Welcome to Moda Operandi"
      onHide={() => {
        tc.track('Welcome Window Quit Clicked');
        onHide();
      }}
    >
      <Text>Thank you for confirming your email address. Your account is now ready to use.</Text>
      <Button
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        onClick={() => {
          tc.track('Welcome Window Start Shopping Clicked');
          handleHide();
        }}
      >
        Start Shopping
      </Button>
    </EmailVerificationStatusModal>
  );
};
